'use client';

import { c as _c } from "react/compiler-runtime";
import { useHydrateAtoms } from 'jotai/utils';
import type { WritableAtom } from 'jotai';
export const Jotai_AtomsHydrator: React.FC<React.PropsWithChildren<{
  values: Iterable<readonly [WritableAtom<unknown, [any], unknown>, unknown]>;
}>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.values) {
    t0 = new Map(props.values);
    $[0] = props.values;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useHydrateAtoms(t0);
  return props.children;
};